import { render, staticRenderFns } from "./TaxForm.vue?vue&type=template&id=25d16fa6&"
import script from "./TaxForm.vue?vue&type=script&lang=js&"
export * from "./TaxForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxForm.vue?vue&type=style&index=0&id=25d16fa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports